import { render, staticRenderFns } from "./HotelsTab.vue?vue&type=template&id=67b1d7c0&scoped=true"
import script from "./HotelsTab.vue?vue&type=script&lang=ts"
export * from "./HotelsTab.vue?vue&type=script&lang=ts"
import style0 from "./HotelsTab.vue?vue&type=style&index=0&id=67b1d7c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b1d7c0",
  null
  
)

export default component.exports